import React from 'react'
import { Button } from 'antd'

const UtilityDrawerFooter = ({onClose}) => {
  return (
    <div style={{ textAlign: 'right' }}>
      <Button type="primary" onClick={onClose}>Close</Button>
    </div>
  )
}

export default UtilityDrawerFooter